import type { Membership } from "./channel-lineup.types";

/**
 * The two section rules the resolver (`lib/channel-lineup/resolve-lineup-for.ts`) and the grid
 * (`signature-grid.shared.ts`) must agree on, written once. No runtime imports, so the server path
 * pulls in nothing else from the organism.
 */

/** An add-on or promo in ANY package. Matches v2's channel-level
 *  `isAddOnPromoAny` (`ChlupStore/chlupStore.ts:452-477`). */
export function isAddonAnywhere(packages: Readonly<Record<string, Membership>> | undefined): boolean {
  return Object.values(packages ?? {}).some(membership => membership === "addon" || membership === "promo");
}

/** GR7: MyFree is `myFree`, plus the satellite `fastChannel` rule. */
export function isMyFreeRow(
  channel: { myFree: boolean; fastChannel: boolean },
  platform: "ott" | "satellite"
): boolean {
  return channel.myFree || (platform === "satellite" && channel.fastChannel);
}
